import { Profile as HygraphProfileProps } from '@/lib/types';

import Profile from '@/components/card';

import profileTransformer from '@/hygraph/transformers/profile.transformer';

export default function ProfileRenderer(props: HygraphProfileProps) {
  return <Profile {...profileTransformer(props)} />;
}
